/* Represents the test web app that uses the AppAuthJS library.
  This Copied and adapted from  https://github.com/openid/AppAuth-JS/blob/master/src/app/index.ts
*/

import {
  UserManager,
  Log,
  WebStorageStateStore
} from '@/external-libs/oidc-client-ts/oidc-client-ts'
// import { UserManager,Log, WebStorageStateStore } from '/Users/erlendo/src/learninghub/tmp/oidc-client-ts/dist/esm/oidc-client-ts'
// import { UserManager,Log, WebStorageStateStore } from 'oidc-client-ts'

import { v4 as uuidv4 } from 'uuid'
import { adminStore } from '@/stores/adminstore.js'

/* Some interface declarations for Material design lite. */

/* an example open id connect provider */
const openIdConnectUrl = 'https://test.idporten.no' // .well-known/oauth-authorization-server' // 'https://test.maskinporten.no/' // FEIDE: 'https://auth.dataporten.no'
const clientId = '59139c58-058a-4d36-a0f0-458ab7312a26' //'c1c0d560-b4e1-427b-a008-70f346cfcf92' //  maskin porten test.
const clientSecret = '990996e1-8da2-4c88-a716-f11373006367' //'5aecc751-1ac1-410f-94ee-37f60738ae5c' // '56583300-750d-4515-8c5c-70ffee9a9495' //'743f3c4c-bb53-411e-967f-3ac0460138ee' // ID porten client secret
const clientName = 'LH - TEST IdPorten'

// const clientSecret = 'a2d5fb15-a0fb-4538-a5ad-cc1751a53c80'
const scope = 'openid profile'

// 'userid profile groups-edu groups-org openid longterm userid-feide id_token token refresh_token userinfo-photo'

console.info('HOSTNAME (%s)', location.hostname)

let redirectUri = ''
let postRedirectUri = ''
if (location.hostname === 'skolestart.localhost') {
  redirectUri = 'http://skolestart.localhost:8301/callback'
  postRedirectUri = 'http://skolestart.localhost:8301/logout'
} else {
  if (location.hostname === 'stage-skolestart.learning-hub.no') {
    redirectUri = 'https://stage-skolestart.learning-hub.no/callback'
    postRedirectUri = 'https://stage-skolestart.learning-hub.no/logout'
  } else if (location.hostname === 'skolestart.learning-hub.no') {
    redirectUri = 'https://skolestart.learning-hub.no/callback'
    postRedirectUri = 'https://skolestart.learning-hub.no/logout'
  }
}
console.log('====================== GET OS HOSTNAME : (%s)', location.hostname)
console.log('====================== GET REDIRECT URI : (%s)', redirectUri)

/*
oauth.Client = {
  client_id: '2855357a-6f92-4f27-908e-cefb276a7997',
  client_secret:'0d1fa311-332e-42cb-92be-47df438181af',
  token_endpoint_auth_method: 'client_secret_basic',
}
*/
export class IdPortenAppAuth {
  code_verifier = null
  code_challenge = null
  authorizationUrl = null
  code_challenge_method = 'S256'
  current_url = null
  client = {}
  client_id = ''
  code = ''
  state = ''
  userManager = UserManager

  /* https://docs.digdir.no/docs/idporten/oidc/oidc_protocol_authorize.html */

  oidcSettings = {
    //      display_name: 'Learning Hub AS',
    authority: openIdConnectUrl,
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: scope,
    state: getState(), // '1234567890',
    nonce: uuidv4(), // '1234567890',
    acr_values: 'idporten-loa-substantial', // "idporten-loa-low", //
    ui_locales: 'nb',
    prompt: 'login', // 'consent', // 'none'
    //      code_challenge: this.code_challenge,
    code_challenge_method: 'S256',
    client_secret: clientSecret,
    client_name: clientName,
    //      authorization_endpoint: openIdConnectUrl,
    post_logout_redirect_uri: postRedirectUri,
    // silent_redirect_uri: redirectUri,
    // post_logout_redirect_uri: `${redirectUri}`,
    // metadata: "https://test.idporten.no/.well-known/openid-configuration",
    grant_type: 'authorization_code',
    // acr_values: "Level3",
    disablePKCE: false,
    revokeAccessTokenOnSignout: true,
    // metadataUrl: 'https://test.maskinporten.no/',
    userinfo_endpoint: 'https://test.idporten.no/userinfo',
    loadUserInfo: true,
    client_authentication: 'none', //'client_secret_post', // 'private_key_jwt', // 'none', // 'private_key_jwt', // 'client_secret_post', // 'private_key_jwt',// 'none', // 'client_secret_basic', //
    revokeAccessTokenOnSignout: true,
    response_mode: 'query', // ' // 'fragment' // 'query' //
    userStore: new WebStorageStateStore({ store: window.localStorage })
    /*
    extraTokenParams: {
      client_id: clientId,
      client_secret: clientSecret
    }
    */
  }
  constructor() {
    console.log('AppAuth constructor got called !')
    console.log(this.oidcSettings)
    this.userManager = new UserManager(this.oidcSettings)
    console.log('UserManager instantiated !', this.userManager)
    Log.logger = console //.setLogger(console)
    // Log.setLogger(console)
    // Log.logger = console;
    Log.level = Log.DEBUG
  }

  setCodeStatus(code, state) {
    console.log('setCodeStatus got called: (%s)', state)
    this.state = state
    console.log('state: (%s)', this.state)
    this.code = code
    console.log('code: (%s)', this.code)
  }

  fetchServiceConfiguration() {
    return new Promise((resolve, reject) => {
      console.log('fetchServiceConfiguration got called !')
      resolve('OK')
    }) // promise
  }

  async fetchServiceConfigurationToken(code, state) {
    return new Promise((resolve) => {
      console.log('fetchServiceConfigurationToken got called !')
      console.log('code: (%s)', code)
      console.log('state: (%s)', state)
      //    console.log(this.userManager)
      //    console.log('REDIRECT (%s)', window.location.href)
      //      console.log('REDIRECT HASH (%s)', window.location.hash)
      //     this.userManager.settings.state = state
      //  this.userManager.settings.client_id = clientId
      //     this.userManager.state = state
      this.userManager.client_id = clientId
      // this.userManager.signinRedirectCallback().then(res => {
      //  this.userManager.signinPopupCallback().then(res => {
      // this.userManager.signinCallback().then(res => {
      //  this.userManager.signinCallback({client_id:clientId, state:state} ,window.location.href).then(res => {
      //  this.userManager.signinRedirectCallback({client_id: clientId , state: state}).then(res => {
      console.log('UserManager: (%j)', this.userManager)
      this.userManager
        .signinCallback({ client_id: clientId, state: state, code: code })
        .then((res) => {
          console.log('====== signinCallback returned ...')
          console.log(res)
          let authResults = {
            success: true,
            accessToken: res.access_token,
            idToken: res.id_token,
            refreshToken: res.refresh_token,
            expiresAt: res.expires_at
          }
          resolve(authResults)
        })
        .catch((err) => {
          console.log('***ERROR*** signinCallback got called ...')
          console.error(err)
          resolve({ error: true, errorMsg: err.toString() })
        })
    })
  }

  makeAuthorizationRequest() {
    console.log('====== makeAuthorizationRequest got called ...')
    return new Promise((resolve) => {
      // create a request
      if (this.userManager) {
        console.log('WE HAVE USER MANAGER ')
        console.log(this.userManager)
        //  this.userManager.signinPopup({state: this.state, client_id: this.client_id}).then(res => {
        this.userManager
          .signinRedirect({ client_id: clientId, state: this.state })
          .then((res) => {
            console.log('====== signinRedirectCallback got called ...')
            console.log(res)
            resolve('ok')
          })
          .catch((err) => {
            console.log('***ERROR*** signinRedirectCallback got called ...')
            console.log(err)
            resolve('error')
          })
      } else {
        resolve('noUserManager')
      }
    }) // promise
  }

  makeRefreshTokenRequest(code) {
    console.log('========= makeRefreshTokenRequest got called ! (' + code + ')')
    return new Promise((resolve) => {
      resolve('ok')
    }) // promise
  }

  makeTokenRequest(code) {
    return new Promise((resolve, reject) => {
      console.log(
        '========= MakeTokenRequest(code) got called ! code:(' + code + ')'
      )
      resolve('ok')
    }) // promise
  }

  loggedIn() {
    return !!this.accessTokenResponse && this.accessTokenResponse.isValid()
  }

  async logout() {
    return new Promise((resolve, reject) => {
      console.log('logout got called !')
      this.userManager.signoutRedirect()
      this.state = null
      this.userManger = null
      this.code = null
      this.oidcSettings = {}
      resolve({ success: true })
    }) // promise
  }

  signOut() {
    // forget all cached token state
    this.userManager.signoutCallback()
    this.code = null
    this.state = null
    this.accessTokenResponse = undefined
    this.userManager = null
    /*   this.userManager.signOutRedirect({redirectMethod:'replace', redirectTarget: 'self'})
          .then(res => {
            console.log('====== signOutSilent got called ...')
            console.log(res)
          })
          */
  }

  checkForAuthorizationResponse() {
    return new Promise((resolve) => {
      console.log('checkForAuthorizationResponse got called !!')

      resolve('ok')
    }) // promise
  }
}

function getState() {
  if (window.localStorage.getItem('state')) {
    return window.localStorage.getItem('state')
  } else {
    let state = uuidv4()
    window.localStorage.setItem('state', state)
    return state
  }
}
